import ProductCarousel from "components/source/shared/carousels/product-carousel";
import { connect } from "react-redux";
import { mapDiscoProductToCarouselProduct } from "helpers/disco-filter-helpers";
import PropTypes from "prop-types";
import { userDataPropType } from "components/propTypes";

const DiscoPoweredCarousel = props => {
  const { title, userData, products, pixelName, type } = props;

  const sanitizedProducts = products.map(product => mapDiscoProductToCarouselProduct(product));

  // Derived from PDP logging properties
  const commonLogProperties = () => {
    // changes display name to underscore separated string, e.g. 'You may also like' to 'you_may_also_like'
    const all_products = JSON.stringify(products.map(product => product?.id));
    return {
      label: pixelName,
      all_products,
    };
  };

  return (
    <>
      <h3 className="ml-3 mb-0 text-xl lg:text-h3 lg:ml-20">{title}</h3>
      {sanitizedProducts.length > 0 && (
        <div className="mt-2">
          <ProductCarousel
            closeModal={() => null}
            customHeartLoggingOptions={commonLogProperties()}
            dispatch={() => null}
            extraPixelData={[]}
            isRentable={false} // how do we determine this?
            isFullBleedCarousel={true}
            isPeekCarousel={true}
            loading={false}
            products={sanitizedProducts}
            type={type}
            userData={userData}
            noModelImageFirst={true}
            isPdpCarousel={true}
          />
        </div>
      )}
    </>
  );
};

DiscoPoweredCarousel.propTypes = {
  title: PropTypes.string,
  userData: userDataPropType,
  products: PropTypes.any,
  pixelName: PropTypes.string,
  type: PropTypes.string,
};

const mapStateToProps = state => ({
  userData: state.userData,
});

export default connect(mapStateToProps, null)(DiscoPoweredCarousel);
